let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bfO34")).then(() => parcelRequire('lQS7P'));